export const CURRENCIES = ["CHF", "EUR", "USD", "GBP"] as const;
export type Currency = (typeof CURRENCIES)[number];

// Static FX rates (relative to CHF=1). Refresh weekly when shipping for real.
const FX: Record<string, number> = {
  CHF: 1.0,
  EUR: 1.05,
  USD: 0.88,
  GBP: 1.21,
};

export function convertPrice(minorUnits: number, from: string, to: string): number {
  if (from === to) return minorUnits;
  const fromRate = FX[from] ?? 1;
  const toRate = FX[to] ?? 1;
  const inCHF = minorUnits * fromRate;
  return Math.round(inCHF / toRate);
}
